export const getAccessToken = () => localStorage.getItem('accessToken');
export const setAccessToken = (token: string) => localStorage.setItem('accessToken', token);

export const setSeqMobileMembers = (id: string) => localStorage.setItem('seqMobileMembers', id);
export const getSeqMobileMembers = () => localStorage.getItem('seqMobileMembers');

const AUTH_KEYS = ['autoLoginYn', 'accessToken', 'refreshToken'] as const; // localStorage, Cookie에서 제거할 키 목록

const deleteLocalStorage = (key: string) => {
  localStorage.removeItem(key);
};

const removeCookie = (name: string) => {
  let date = new Date();
  date.setDate(date.getDate() - 100);
  let Cookie = `${name}=;Expires=${date.toUTCString()}`;
  document.cookie = Cookie;
};

// 로컬 저장소에 저장된 로그인 정보 싹 다 제거 (localStorage & Cookie)
export const clearAuthStorage = (): void => {
  AUTH_KEYS.forEach((key) => {
    deleteLocalStorage(key);
    removeCookie(key);
  });
};
